var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 4.625H6.375V1.125C6.375 0.892936 6.28281 0.670376 6.11872 0.506282C5.95462 0.342187 5.73206 0.25 5.5 0.25C5.26794 0.25 5.04538 0.342187 4.88128 0.506282C4.71719 0.670376 4.625 0.892936 4.625 1.125V4.625H1.125C0.892936 4.625 0.670376 4.71719 0.506282 4.88128C0.342187 5.04538 0.25 5.26794 0.25 5.5C0.25 5.73206 0.342187 5.95462 0.506282 6.11872C0.670376 6.28281 0.892936 6.375 1.125 6.375H4.625V9.875C4.625 10.1071 4.71719 10.3296 4.88128 10.4937C5.04538 10.6578 5.26794 10.75 5.5 10.75C5.73206 10.75 5.95462 10.6578 6.11872 10.4937C6.28281 10.3296 6.375 10.1071 6.375 9.875V6.375H9.875C10.1071 6.375 10.3296 6.28281 10.4937 6.11872C10.6578 5.95462 10.75 5.73206 10.75 5.5C10.75 5.26794 10.6578 5.04538 10.4937 4.88128C10.3296 4.71719 10.1071 4.625 9.875 4.625Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSvg);
export default __webpack_public_path__ + "static/media/plus-svg.81ca64f87cdba23ee0dd37f8c38270b4.svg";
export { ForwardRef as ReactComponent };